// index小仓库
import { reqClassify, reqClassifyLenght, reqByClassifyId, sumTransactionNum, slideShow, getOrganization } from '@/api';
// const TOKEN_KEY = 'TOUTIAO_USER'

const state = {
    token: localStorage.getItem('token'),
    listByparent: [],
    byclassify: [],
    byclassifylength: 0,
    sumNum: {},
    sShow: [],
    organizaTion: [],
    organizaTionAll: []
};
// mutions是唯一修改state的地方
const mutations = {
    GETTOKENS(state, data) {
        state.token = data;
    },
    LISTBYPARENID(state, listByparent) {
        state.listByparent = listByparent;
    },
    LISTBYPARENIDLENGTH(state, byclassifylength) {
        state.byclassifylength = byclassifylength;
    },
    REQBYCLASSIFYID(state, byclassify) {
        state.byclassify = byclassify;
    },
    SUMTRANSACTIONMUB(state, sumNum) {
        state.sumNum = sumNum;
    },
    SLIDESHOW(state, sShow) {
        state.sShow = sShow;
    },
    ORGANIZATION(state, organizaTion) {
        state.organizaTion = organizaTion;
    },
    ORGANIZATIONALL(state, organizaTionAll) {
        state.organizaTionAll = organizaTionAll;
    }
};
// action|用户处理派发action地方的，可以书写异步语句、自己逻辑地方
const actions = {
    // 三级分类1
    async ListByParentId({ commit }, params) {
        // console.log("departmentId",params);
        const res = await reqClassify(params);
        if (res.result == 200) {
            commit('LISTBYPARENID', res.rows);
        }
    },
    // 三级分类2
    async reqClassifyLenght({ commit }, params) {
        const res = await reqClassifyLenght(params);
        if (res.result == 200) {
            commit('LISTBYPARENIDLENGTH', res.rows.length);
        }
    },
    // 三级分类3
    async reqByClassifyId({ commit }, params) {
        // console.log("reqByClassifyId",params);
        const res = await reqByClassifyId(params);
        if (res.result == 200) {
            // console.log("res",res);
            commit('REQBYCLASSIFYID', res);
        }
    },

    async sumTransactionNum({ commit }) {
        const res = await sumTransactionNum();
        if (res.result == 200) {
            commit('SUMTRANSACTIONMUB', res.data);
        }
    },
    async slideShow({ commit }) {
        const res = await slideShow();
        if (res.result == 200) {
            commit('SLIDESHOW', res.data);
        }
    },
    // 获取部门
    async Organization({ commit }) {
        const res = await getOrganization();
        // console.log("res111", res);
        // let dep = []
        // for (let index = 0; index < 8; index++) {
        //     dep[index] = res.rows[index];
        // }
        // console.log("dep", dep);
        // if (res.result == 200) {
        //     commit("ORGANIZATION", dep)
        // }
    },
    // 获取全部部门
    async OrganizationAll({ commit }) {
        const res = await getOrganization();
        if (res.result == 200) {
            commit('ORGANIZATIONALL', res.rows);
        }
    }
};
// 计算属性
const getters = {
    getlistByparent: state => {
        try {
            return state.listByparent;
        } catch {
            return {};
        }
    }
};
export default {
    state,
    mutations,
    actions,
    getters
};
